import {
  Box,
  Button,
  Collapse,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import "./ChadhavaSubscription.scss";
import ChadhavaItemList from "../chadhavaItemList/ChadhavaItemList";
import ChadhavaPlanSelector from "../chadhavaPlanSelector/ChadhavaPlanSelector";
import { CAROUSEL_REMOVE_ARRAOW_ON_DEVICE } from "../../utils/Constants";
import { useTranslation } from "react-i18next";
import { LOCALIZATION } from "../../utils/localization";
import React from "react";
import { useSelector } from "react-redux";
import {
  calculateDiscountedPrice,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import Carousel from "react-multi-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { CHADHAVA_SUB_ADDON_SCROLL_RESPONSIVE } from "../../utils/cssConstants";

const ChadhavaSubscription = (props: any) => {
  const {
    subscriptionChadhavaList,
    onClickChadhavaItem,
    chadhavaSubscriptions,
    subscriptionAddOn,
    handleAddFromAddOn,
    selectedChadhavaSubscriptionPlan,
    onSelectSubscriptionPlan,
    totalSubscriptionPrice,
    templeName,
  } = props;
  const { t } = useTranslation();
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState.priceConversionRate || {};

  const isMobile = useMediaQuery("(max-width:600px)");
  const itemsPerRow = isMobile ? 3 : 4;

  const handleSelectChadhava = (id: any) => {
    onClickChadhavaItem(id);
  };

  const tempTotalSelectedChadhavaPrice = isOverseas
    ? totalSubscriptionPrice?.totalFinalPriceOv ?? 0
    : totalSubscriptionPrice?.totalFinalPrice ?? 0;
  let cutPriceWithSubscription = 0;
  if (selectedChadhavaSubscriptionPlan?.subscriptionId) {
    cutPriceWithSubscription = truncateToTwoDecimals(
      calculateDiscountedPrice(
        tempTotalSelectedChadhavaPrice,
        Number(selectedChadhavaSubscriptionPlan?.fixDiscount)
      )
    );
  }
  const isAnyChadhavaSelected = subscriptionChadhavaList?.some(
    (item: any) => item?.count
  );
  return (
    <Box className="chadhavaSubscriptionArea">
      <Box id="chadhava-Chadhava_Offering_Subscription_Plan">
        <Box className="aboutSubscription">
          <Typography className="title">
            {t(LOCALIZATION?.Chadhava_Offering_Subscription_Plan)}
          </Typography>

          <Typography className="description">
            {t(
              LOCALIZATION?.The_following_chadhava_offerings_will_be_made_every
            )}{" "}
            {selectedChadhavaSubscriptionPlan?.title ?? ""}{" "}
            {t(LOCALIZATION?.throughout_the_month_at)} {templeName ?? ""}.
          </Typography>
        </Box>

        <Collapse in={!isAnyChadhavaSelected} timeout={400} unmountOnExit>
          <Box className="subscriptionDisclaimer">
            <Typography>
              {t(
                LOCALIZATION?.Please_select_at_least_one_chadhava_item_to_continue
              )}
            </Typography>
          </Box>
        </Collapse>

        <Box className="chadhavaItemList">
          <Grid container spacing={2} className="productGrid">
            {subscriptionChadhavaList?.map((item: any, index: number) => {
              const isRowEnd =
                (index + 1) % itemsPerRow === 0 &&
                index + 1 < subscriptionChadhavaList?.length;

              return (
                <React.Fragment key={item?.id}>
                  <Grid item md={3} xs={4} className="newItemAnimation">
                    <ChadhavaItemList
                      name={item?.name || ""}
                      chadhavaPic={item?.image}
                      price={
                        isOverseas
                          ? item?.priceInfo?.finalPriceOv
                          : item?.priceInfo?.finalPrice
                      }
                      currency={currencySymbols}
                      checked={!!item?.count}
                      onSelectChange={() => {
                        handleSelectChadhava(item?.id);
                      }}
                    />
                  </Grid>

                  {isRowEnd && (
                    <Grid item xs={12}>
                      <Box className="rowDivider" />
                    </Grid>
                  )}
                </React.Fragment>
              );
            })}
          </Grid>
          {/* Subscription add ons */}
          {subscriptionAddOn?.length > 0 && (
            <Divider
              sx={{
                borderBottom: "3px solid #fff",
                paddingTop: "0.8rem",
              }}
            />
          )}
        </Box>
      </Box>
      {subscriptionAddOn?.length > 0 && (
        <Box className="subscriptionAddons" id="subscription_Add_ons">
          <Typography className="subscriptionAddonsTitle">
            {t(LOCALIZATION?.Subscription_Add_ons)}
          </Typography>
          <Box className="productCardCarousel">
            <Carousel
              responsive={CHADHAVA_SUB_ADDON_SCROLL_RESPONSIVE}
              swipeable
              draggable
              keyBoardControl
              containerClass="carousel-container"
              itemClass="carousel-item-padding-40-px"
              removeArrowOnDeviceType={CAROUSEL_REMOVE_ARRAOW_ON_DEVICE}
              showDots={false}
            >
              {subscriptionAddOn?.map((item: any) => {
                return (
                  <ChadhavaItemList
                    key={item?.id}
                    name={item?.name || ""}
                    chadhavaPic={item?.image}
                    price={
                      isOverseas
                        ? truncateToTwoDecimals(item?.priceInfo?.finalPriceOv)
                        : item?.priceInfo?.finalPrice
                    }
                    currency={currencySymbols}
                    checked={!!item?.count}
                    onSelectChange={() => {
                      handleAddFromAddOn(item);
                    }}
                  />
                );
              })}
            </Carousel>
          </Box>
        </Box>
      )}
      <Box className="chadhavaItemList">
        {(tempTotalSelectedChadhavaPrice > 0 ||
          cutPriceWithSubscription > 0) && (
          <Box className="proceedBtn">
            <Button>
              {tempTotalSelectedChadhavaPrice > 0 && (
                <span>
                  {currencySymbols}
                  {truncateToTwoDecimals(tempTotalSelectedChadhavaPrice)}
                </span>
              )}
              {cutPriceWithSubscription > 0 &&
                `${currencySymbols}${cutPriceWithSubscription}`}
            </Button>
          </Box>
        )}
      </Box>

      <Divider
        sx={{
          borderBottom: "3px solid #fff",
          paddingTop: "1rem",
        }}
      />

      <Box className="chadhavaPlanArea" id="select_your_Chadhava_plan">
        <Typography className="planAreaTitle">
          {t(LOCALIZATION?.Select_your_Chadhava_plan)}
        </Typography>

        <Box className="planList">
          {chadhavaSubscriptions?.map((plan: any) => (
            <ChadhavaPlanSelector
              key={plan?.subscriptionId}
              isPlanSelected={
                selectedChadhavaSubscriptionPlan?.subscriptionId ===
                plan?.subscriptionId
              }
              title={plan?.title ?? ""}
              description={plan?.description ?? ""}
              onChange={() => onSelectSubscriptionPlan(plan)}
              price={
                tempTotalSelectedChadhavaPrice
                  ? calculateDiscountedPrice(
                      tempTotalSelectedChadhavaPrice,
                      Number(plan?.fixDiscount)
                    )
                  : 0
              }
              currency={currencySymbols}
              frequency={Number(plan?.frequency ?? 0) ?? 0}
              discount={Number(plan?.fixDiscount ?? 0) ?? 0}
              cuttedPrice={truncateToTwoDecimals(
                tempTotalSelectedChadhavaPrice * plan?.frequency
              )}
            />
          ))}
        </Box>
      </Box>
      <Divider
        sx={{
          borderBottom: "3px solid #fff",
          paddingTop: "0.8rem",
        }}
      />
    </Box>
  );
};
export default ChadhavaSubscription;
